<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="ibox-content m-b-sm border-bottom">
      <div class="row form-horizontal">
        <div class="panel-body">
          <div class="ibox-content">
            <el-form :model="detailInfo" ref="detailInfo" label-width="0px" class="demo-dynamic form-horizontal detailPage">
              <div style="padding-bottom: 20px">Backgroud image of the My Voucher, Bookmarks and My eTicket icon</div>

              <div class="form-group">
                <label class="col-sm-4 control-label"> Guest & MyWestK member </label>
                <div class="col-sm-8">
                  <el-form-item
                    prop="guestMywestkMember"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-input v-model="detailInfo.guestMywestkMember"></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-4 control-label">HKPM Friends </label>
                <div class="col-sm-8">
                  <el-form-item
                    prop="hkpmFriends"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-input v-model="detailInfo.hkpmFriends"></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-4 control-label"> M+ Member </label>
                <div class="col-sm-8">
                  <el-form-item
                    prop="maddMember"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-input v-model="detailInfo.maddMember"></el-input>
                  </el-form-item>
                </div>
              </div>
            </el-form>
          </div>
        </div>
        <div class="form-group">
          <div class="col-sm-12 textRight">
            <div class>
              <button class="btn btn btn-primary" v-if="checkPermission('BACKGROUND_AT_THE_TOP_ICON')" @click="checkEvent">{{ $t("message.Save") }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import eventBus from "../eventbus";
import config from "../config";

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      detailInfo: {
        "guestMywestkMember": "",
        "hkpmFriends": "",
        "maddMember": "",
      },
    };
  },
  created() {},
  methods: {
    async init() {
      this.getBackgroudTopIconEvent();
    },
    async getBackgroudTopIconEvent() {
      let objdata = this.getAuthObj();
      objdata.apiUrl = "/getBackgroudTopIcon";
      var data = await this.$store.dispatch("apiEvent", objdata);
      if (!data) return;
      if (data.data.errorCode === 0) {
        if (data.data.result == null) {
          this.detailInfo = {
            "guestMywestkMember": "",
            "hkpmFriends": "",
            "maddMember": "",
          };
        } else {
          this.detailInfo = data.data.result;
        }
      }
    },
    checkEvent: function () {
      this.$refs["detailInfo"].validate(valid => {
        if (valid) {
          this.saveBackgroudTopIcon();
        } else {
          this.$toastr.w(this.$i18n.t("message.fillRequired"));
          return false;
        }
      });
    },
    async saveBackgroudTopIcon() {
      let objdata = this.getAuthObj();
      objdata.hkpmFriends = this.detailInfo.hkpmFriends;
      objdata.guestMywestkMember = this.detailInfo.guestMywestkMember;
      objdata.maddMember = this.detailInfo.maddMember;
      objdata.apiUrl = "/saveBackgroudTopIcon";
      var data = await this.$store.dispatch("apiEvent", objdata);
      if (!data) return;
      if (data.data.errorCode === 0) {
        this.$toastr.s("Success");
        window.scroll(0, 0);
        this.getBackgroudTopIconEvent();
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>
